import React, { Fragment, Component, PureComponent } from "react";
import styled, { keyframes, css } from "styled-components";

const entering = keyframes`
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
`;

const exiting = keyframes`
  from {
    transform: scale(1);
  }

  to {
    transform: scale(0);
  }
`;

const Transition = styled.div`
  ${props =>
    props.stage === "entering" &&
    css`
      animation: ${entering} 0.5s forwards;
    `};
  ${props =>
    props.stage === "exiting" &&
    css`
      animation: ${exiting} 0.5s forwards;
    `};
`;

const stages = ["entering", "stable", "exiting"];

export default class TransitionHandler extends Component {
  state = { stage: stages[0], count: 0 };

  getChildren = () => {
    if (this.state.stage === stages[2]) {
      return this.state.outdatedChildren;
    }
    return this.state.actualChildren;
  };

  makeReady = () => {
    const increment = this.state.count + 1;
    if (increment < this.getChildren().length) {
      this.setState({
        count: this.state.count + 1
      });
      return;
    }

    // ready

    const currentIndex = stages.indexOf(this.state.stage);

    this.setState({
      stage: stages[currentIndex < stages.length - 1 ? currentIndex + 1 : 0],
      count: 0
    });
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    const childrenChanged =
      prevState.actualChildren !== nextProps.children &&
      prevState.actualChildren !== undefined;

    // prevent state becoming asynchronous through rapid children changes (during animations)
    if (childrenChanged && prevState.stage !== stages[1]) {
      return prevState;
    }

    return {
      outdatedChildren: childrenChanged
        ? prevState.actualChildren
        : prevState.count !== 0
          ? prevState.outdatedChildren
          : undefined,
      actualChildren: nextProps.children,
      stage: childrenChanged ? stages[2] : prevState.stage
    };
  };

  render = () =>
    this.getChildren().map(child => (
      <Transition
        key={child.key}
        stage={this.state.stage}
        onAnimationEnd={this.makeReady}
        children={child}
      />
    ));
}



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/TransitionHandler.js